import { render, staticRenderFns } from "./campaignGoal.vue?vue&type=template&id=0cc6a661&"
import script from "./campaignGoal.vue?vue&type=script&lang=js&"
export * from "./campaignGoal.vue?vue&type=script&lang=js&"
import style0 from "./campaignGoal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports